import { gql } from '@grandvisionhq/graphql';

const priceFragment = gql`
  fragment PriceFragment on OrderLineItemPrice {
    total {
      subtotal
      discount {
        amount
        percentage
      }
      net
      gross
      tax {
        amount
      }
    }
    unit {
      subtotal
      discount {
        amount
        percentage
      }
      net
      gross
      tax {
        amount
      }
    }
  }
`;
const solutionLineItemFragment = gql`
  fragment SolutionOrderLineItemFragment on OrderLineItemSolution {
    price {
      ...PriceFragment
    }
    quantity
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        type
        availabilityChannels {
          id
          isOnStock
          availableQuantity
        }
      }
      volume
      volumeUnit
    }
  }
  ${priceFragment}
`;
const contactLensLineItemFragment = gql`
  fragment ContactLensOrderLineItemFragment on OrderLineItemContactLens {
    price {
      ...PriceFragment
    }
    quantity
    eyeSide
    prescription {
      addition
      axis
      baseCurve
      cylinder
      dominance
      diameter
      power
    }
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        type
        availabilityChannels {
          id
          isOnStock
          availableQuantity
        }
      }
      boxQuantity
      replacementFrequency {
        locale
        value
      }
    }
  }
  ${priceFragment}
`;
const prescriptionGlassLineItemFragment = gql`
  fragment PrescriptionGlassOrderLineItemFragment on OrderLineItemPrescriptionGlass {
    price {
      ...PriceFragment
    }
    quantity
    configurationDetails {
      configurationType
      description {
        locale
        value
      }
      productPrice
      totalPaid
    }
    prescription {
      ... on AddedGlassesPrescription {
        leftLens {
          pupillaryDistance
          prism
          power
          cylinder
          axis
          addition
        }
        rightLens {
          pupillaryDistance
          prism
          power
          cylinder
          axis
          addition
        }
      }
      ... on EmailPrescription {
        message
      }
      ... on ExistingPrescription {
        message
      }
      ... on FilePrescription {
        prescriptionFileName
        pupillaryDistanceFileName
      }
    }
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        type
        availabilityChannels {
          id
          isOnStock
          availableQuantity
        }
      }
      productPrice
      totalPaid
    }
  }
  ${priceFragment}
`;
const nonPrescriptionBundleOrderLineItemFragment = gql`
  fragment NonPrescriptionBundleOrderLineItemFragment on OrderLineItemNonPrescriptionBundle {
    quantity
    price {
      ...PriceFragment
    }
    product {
      sku
      currentProduct {
        type
        availabilityChannels {
          id
          isOnStock
          availableQuantity
        }
      }
      name {
        locale
        value
      }
      brand
      modelCode
      mainImage
      productPrice
      totalPaid
    }
    configurationDetails {
      configurationType
      description {
        locale
        value
      }
      totalPaid
      productPrice
    }
  }
  ${priceFragment}
`;
const contactLensBundleLineItemFragment = gql`
  fragment ContactLensBundleOrderLineItemFragment on OrderLineItemBundle {
    price {
      ...PriceFragment
    }
    quantity
    product {
      sku
      currentProduct {
        type
        availabilityChannels {
          id
          isOnStock
          availableQuantity
        }
      }
      name {
        locale
        value
      }
      brand
      modelCode
      mainImage
      bundledProductName {
        locale
        value
      }
      lensType {
        locale
        value
      }
    }
    bundledLineItems {
      ... on OrderLineItemContactLens {
        price {
          productPrice
          totalPaid
        }
        quantity
        eyeSide
        prescription {
          addition
          axis
          baseCurve
          cylinder
          dominance
          diameter
          power
        }
        product {
          brand
          mainImage
          modelCode
          name {
            locale
            value
          }
          sku
          currentProduct {
            type
            availabilityChannels {
              id
              isOnStock
              availableQuantity
            }
          }
          # 09.06.22: boxQuantity is disabled explicitly because it breaks the validation on
          # GraphQL side. This property is going to be deprecated from the graph, but is kept for documentation
          # boxQuantity
          replacementFrequency {
            locale
            value
          }
        }
      }
      ... on OrderLineItemSolution {
        ...SolutionOrderLineItemFragment
      }
    }
  }
  ${contactLensLineItemFragment}
  ${solutionLineItemFragment}
  ${priceFragment}
`;
const regularLineItemFragment = gql`
  fragment RegularOrderLineItemFragment on OrderLineItemRegular {
    price {
      ...PriceFragment
    }
    quantity
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        type
        availabilityChannels {
          id
          isOnStock
          availableQuantity
        }
      }
    }
  }
  ${priceFragment}
`;

export { contactLensBundleLineItemFragment, contactLensLineItemFragment, nonPrescriptionBundleOrderLineItemFragment, prescriptionGlassLineItemFragment, regularLineItemFragment, solutionLineItemFragment };
//# sourceMappingURL=line-item.js.map
